import { Scale } from "../../../utils/Scale"

export class LongPos {
    static ratX = () => Scale.width() * 0.35
    static ratY = () => Scale.height() * 0.7

    static transparentBoxX = () => Scale.width() * 0.1
    static transparentBoxY = () => 0

    static smokeX = () => Scale.width() * 0.63
    static smokeY = () => Scale.height() * 0.305
}
